import React, { createElement } from "react";
import { red, blue, green } from "@material-ui/core/colors";
import { AutoRotatingCarousel, Slide } from "material-auto-rotating-carousel";

const AutoRotatingCarouselModal = ({ handleOpen, setHandleOpen, isMobile }) => {
  return (
    <AutoRotatingCarousel
      label="Get started"
      open={handleOpen.open}
      onClose={() => setHandleOpen({ open: false })}
      onStart={() => setHandleOpen({ open: false })}
      autoplay={true}
      mobile={isMobile}
      style={{ position: "absolute" }}
    >
      <Slide
        media={
          <img
            src="https://www.flaticon.com/svg/static/icons/svg/3468/3468306.svg"
            style={{ width: "40%" }}
          />
        }
        mediaBackgroundStyle={{ backgroundColor: red[400] }}
        style={{ backgroundColor: red[600] }}
        title="This is a very cool website"
        subtitle="Just using this will blow your mind."
      />
      <Slide
        media={
          <img
            src="https://www.flaticon.com/svg/static/icons/svg/3468/3468170.svg"
            style={{ width: "40%" }}
          />
        }
        mediaBackgroundStyle={{ backgroundColor: blue[400] }}
        style={{ backgroundColor: blue[600] }}
        title="Ever wanted to be popular?"
        subtitle="Well just mix two colors and your are good to go!"
      />
      <Slide
        media={
          <img
            src="https://www.flaticon.com/svg/static/icons/svg/3468/3468419.svg"
            style={{ width: "40%" }}
          />
        }
        mediaBackgroundStyle={{ backgroundColor: green[400] }}
        style={{ backgroundColor: green[600] }}
        title="May the force be with you"
        subtitle="The Force is a metaphysical and ubiquitous power in the Star Wars fictional universe."
      />
    </AutoRotatingCarousel>
  );
};
export default AutoRotatingCarouselModal;
